<script>
import axios from "axios";
import Swal from "sweetalert2";
import $ from "jquery";

export default {
    name: "form-edit-materi",
    props: ['idData'],
    data() {
        return {
            axiosCatchError: "",
            id: this.idData,
            mPembelajaran_kode: "",
            mPembelajaran_nama: "",
            mPembelajaran_deskripsi: "",
            mPembelajaran_link: "",
        };
    },
    mounted() {
    Swal.fire({
      title: '<i class="fas fa-spinner fa-spin"></i>',
      text: "Loading...",
      showConfirmButton: false,
    });
    let self = this;
    var config_data_edit = {
      method: "get",
      url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/materi-pembelajaran",
      params: {
        id: self.id,
      },
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.access_token,
      },
    };
    axios(config_data_edit)
      .then(function (response) {
        var response_data = response.data;
        var response_data_fix = response_data.data[0];
        if (response_data.meta.code == 200) {
          var data_edit = response_data_fix;
          self.mPembelajaran_kode = data_edit.lm_code;
          self.mPembelajaran_nama = data_edit.lm_name;
          self.mPembelajaran_deskripsi = data_edit.lm_description;
          self.mPembelajaran_link = data_edit.lm_link;
          // data_edit.lm_docs.forEach(elm => {
          //   var noFileNew = self.mBerkas.length + 1
          //   var objFile = { idData: elm.lmd_id, count: self.mBerkas.filter(x => x.isDelete == false).length + 1, no: noFileNew, id: `file_${noFileNew}`, uploadLoading: `uploadLoading_${noFileNew}`, path: "", isDelete: false }
          //   self.mBerkas.push(objFile)
          // });
        } else {
          console.log(response_data_fix.data.message);
        }
        Swal.close()
      })
      .catch(function (error) {
        Swal.close()
        console.log(error);
      });
  },
  methods: {
    validationForm() {
      if (!this.mPembelajaran_kode || !this.mPembelajaran_nama || !this.mPembelajaran_deskripsi || !this.mPembelajaran_link) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terdapat inputan kosong!",
        });
        return
      }
      this.storeData()
    },
    storeData() {
      let self = this;
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
      });

      var config_store_data = {
        method: "put",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/materi-pembelajaran",
        data: {
          id: self.id,
          mPembelajaran_kode: self.mPembelajaran_kode,
          mPembelajaran_nama: self.mPembelajaran_nama,
          mPembelajaran_deskripsi: self.mPembelajaran_deskripsi,
          mPembelajaran_link: self.mPembelajaran_link,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config_store_data)
        .then(function (response) {
          console.log(response);
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Data berhasil di simpan.",
            timer: 2000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
          }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
              Swal.close();
              self.$emit("refresh-table");
            }
          });
        })
        .catch(function (error) {
          Swal.close();
          self.axiosCatchError = error.response.data.data;
        });
    },
    addBerkas() {
      var noFileNew = this.mBerkas.length + 1
      var objFile = { idData: null, count: this.mBerkas.filter(x => x.isDelete == false).length + 1, no: noFileNew, id: `file_${noFileNew}`, uploadLoading: `uploadLoading_${noFileNew}`, path: "", isDelete: false }
      this.mBerkas.push(objFile)
    },
    deleteBerkas(id) {
      this.mBerkas[id] = {
        ...this.mBerkas[id],
        isDelete: true
      }

      var count = 1;
      for (var i = 0; i < this.mBerkas.length; i++) {
        if (this.mBerkas[i].isDelete == false) {
          this.mBerkas[i] = {
            ...this.mBerkas[i],
            count: count++
          }
        }
      }
    },
    inputFile(id) {
      let self = this;
      console.log(id)
      if ($("#file_" + id)[0].files[0]) {
        if ($("#file_" + id)[0].files[0].size < 2242880) {
          $("#uploadLoading_" + id).html(
            '<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>'
          );
          var urlres = process.env.VUE_APP_BACKEND_URL;
          var FormData = require("form-data");
          var data = new FormData();
          data.append("file", $("#file_" + id)[0].files[0]);
          var config = {
            method: "post",
            url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
            data: data,
          };
          axios(config).then(function (response) {
            console.log(response.data.data.path_file);
            var path_file = response.data.data.path_file;
            urlres += path_file;
            $("#uploadLoading_" + id).html(
              '<span class="badge bg-success p-1"><i class="fa fa-check"></i> Berhasil </span> <a href="' +
              urlres +
              '" target="_blank" style="padding-left:10px;"><span class="badge bg-success p-1"><i class="fa fa-eye"></i> Lihat File</span></a>'
            );
            self.mBerkas[id - 1] = {
              ...self.mBerkas[id - 1],
              path: path_file
            };
          });
        } else {
          alert("Max File 2 MB");
        }
      }
    }
  },
};
</script>
<template>
  <b-form class="p-2" @submit.prevent="validationForm">
    <div class="row">
      <div class="col-12">
        <div v-if="axiosCatchError">
          <div class="alert alert-danger" v-if="typeof axiosCatchError === 'string' ||
            axiosCatchError instanceof String
            ">
            {{ axiosCatchError }}
          </div>
          <div class="alert alert-danger" role="alert" v-else>
            <div v-for="(errorArray, idx) in axiosCatchError" :key="idx">
              <div v-for="(allErrors, idx) in errorArray" :key="idx">
                <span class="text-danger">{{ allErrors[0] }} </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 mt-1">
        <b-form-group label="Kode" label-for="mPembelajaran_kode">
          <b-form-input id="mPembelajaran_kode" placeholder="Masukkan Kode..." type="text"
            v-model="mPembelajaran_kode"></b-form-input>
        </b-form-group>
      </div>
      <div class="col-lg-12 mt-1">
        <b-form-group label="Nama" label-for="mPembelajaran_nama">
          <b-form-input id="mPembelajaran_nama" placeholder="Masukkan Nama..." type="text"
            v-model="mPembelajaran_nama"></b-form-input>
        </b-form-group>
      </div>
      <div class="col-lg-12 mt-1">
        <b-form-group label="Link" label-for="mPembelajaran_link">
          <textarea class="form-control" id="mPembelajaran_link" cols="30" rows="5" placeholder="Masukkan Link"
            v-model="mPembelajaran_link"></textarea>
        </b-form-group>
      </div>
      <div class="col-lg-12 mt-1">
        <b-form-group label="Deskripsi" label-for="mPembelajaran_deskripsi">
          <textarea class="form-control" id="mPembelajaran_deskripsi" cols="30" rows="10" placeholder="Masukkan Deskripsi"
            v-model="mPembelajaran_deskripsi"></textarea>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">&nbsp;</div>
      <!-- end col -->
      <div class="col-lg-6">
        <div class="text-end">
          <b-button type="reset" variant="danger">
            <i class="fa fa-redo-alt"></i> Reset
          </b-button>
          &nbsp;
          <b-button type="submit" variant="primary">
            <i class="fa fa-save"></i> Simpan
          </b-button>
        </div>
      </div>
      <!-- end col -->
    </div>
  </b-form>
</template>
